import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=eaf4e06e&scoped=true&"
import script from "./SubmitButton.vue?vue&type=script&lang=ts&"
export * from "./SubmitButton.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=eaf4e06e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf4e06e",
  null
  
)

export default component.exports